"use strict";
/**
 * Defines the custom errors used in fqm-execution and the use cases for each one.
 * NOTE: regular Errors are also thrown in certain situations where we have limited
 * information on the crash.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsupportedProperty = exports.UnexpectedProperty = exports.UnexpectedResource = exports.ErrorWithDebugInfo = void 0;
var ErrorWithDebugInfo = /** @class */ (function (_super) {
    __extends(ErrorWithDebugInfo, _super);
    function ErrorWithDebugInfo(message, debugOutput) {
        if (debugOutput === void 0) { debugOutput = undefined; }
        var _this = _super.call(this, message) || this;
        _this.debugOutput = debugOutput;
        return _this;
    }
    return ErrorWithDebugInfo;
}(Error));
exports.ErrorWithDebugInfo = ErrorWithDebugInfo;
/** Thrown when a resource is improperly formatted or empty
ex. patient bundle has no entries, measure bundle has no libraries*/
var UnexpectedResource = /** @class */ (function (_super) {
    __extends(UnexpectedResource, _super);
    function UnexpectedResource(message, debugOutput) {
        if (debugOutput === void 0) { debugOutput = undefined; }
        var _this = _super.call(this, message, debugOutput) || this;
        _this.name = 'UnexpectedResource';
        return _this;
    }
    return UnexpectedResource;
}(ErrorWithDebugInfo));
exports.UnexpectedResource = UnexpectedResource;
/** Used when a resource largely valid/syntactically correct, but has conflicting
info, is impossibly formatted, or is missing specific needed fields
ex. Measure Bundle does not contain improvement notation */
var UnexpectedProperty = /** @class */ (function (_super) {
    __extends(UnexpectedProperty, _super);
    function UnexpectedProperty(message, debugOutput) {
        if (debugOutput === void 0) { debugOutput = undefined; }
        var _this = _super.call(this, message, debugOutput) || this;
        _this.name = 'UnexpectedProperty';
        return _this;
    }
    return UnexpectedProperty;
}(ErrorWithDebugInfo));
exports.UnexpectedProperty = UnexpectedProperty;
/** Used when all resources are valid but are requesting services we do not yet support
ex. user is trying to calculate measure reports with a report type other than 'summary' or 'individual'*/
var UnsupportedProperty = /** @class */ (function (_super) {
    __extends(UnsupportedProperty, _super);
    function UnsupportedProperty(message, debugOutput) {
        if (debugOutput === void 0) { debugOutput = undefined; }
        var _this = _super.call(this, message, debugOutput) || this;
        _this.name = 'UnsupportedProperty';
        return _this;
    }
    return UnsupportedProperty;
}(ErrorWithDebugInfo));
exports.UnsupportedProperty = UnsupportedProperty;
//# sourceMappingURL=CustomErrors.js.map